import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-item-bill-tiny',
  template: `
    <div class="d-flex justify-content-between align-items-center">
      <div class="flex-fill">
        <h5 class="mt-1">Recibo anterior</h5>
      </div>
      <div class="flex-shrink-0 mt-0">
        <div class="badge bg-success" *ngIf="bill?.status">Pagado</div>
        <div class="badge bg-danger text-light" *ngIf="!bill?.status">No pagado</div>
      </div>
    </div>
    
    <table class="table table-sm mt-2 border-0" style="font-size: 0.8em;">
      <tbody>
        <tr class="border-bottom-secondary">
          <th colspan="2">Recibo</th>
          <td class="text-end"><a routerLink="/pagos/recibos/{{bill?.id}}"># {{bill?.id}}</a></td>
        </tr>
        <tr class="border-bottom-secondary">
          <th>Vencimiento</th>          
          <td class="text-end"></td>
          <td class="text-end">{{bill?.due_date | date: 'dd/MM/yy'}}</td>
        </tr>
        <tr class="border-bottom-secondary">
          <th>Fecha Pago</th>
          <td></td>
          <!-- td class="text-end">
            <div class="badge bg-success" *ngIf="bill?.status">Pagado</div>
            <div class="badge bg-danger text-light" *ngIf="!bill?.status">No pagado</div>
          </!-->
          <td class="text-end">
            <span *ngIf="!bill?.paid_date">-</span>
            <span *ngIf="bill?.paid_date">{{bill?.paid_date | date: 'dd/MM/yy'}}</span>
          </td>
        </tr>
        <tr class="border-bottom-secondary">
          <th colspan="2">Monto</th>
          <td class="text-end">{{bill?.total | currency}}</td>
        </tr>
      </tbody>
    </table>
  `,
  styleUrls: []
})
export class ItemBillTinyComponent {
  @Input() bill: any;

  constructor() { }
}
